<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblAssignTool</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
            </a>
        </div>
      </div>
      <form [formGroup]="addSpecialToolForm" (ngSubmit)="assignDealerSpecialTool()">
        <div class=" scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="form-row">
                <div class="col-6 af-form-group">
                  <label for="service" translate>lblBrand
                    <strong class="mlt6 required"> * </strong> </label>
                  <div class='lbl-info'>
                    <ng-select class="" formControlName="brand" 
                      [ngClass]="{'is-invalid': cpf.brand.invalid && cpf.brand.touched}" (change)="getPartNumber($event)"
                      placeholder="{{ 'lblSelectBrand' | translate }}">
                      <option selected disabled translate [ngValue]="null" translate>lblSelectCompany</option>
                      <ng-template ng-header-tmp>
                        <span class="mbold w-66px">Code</span>
                        <span class="mbold" translate>lblBrand</span>
                      </ng-template>

                      <ng-option *ngFor="let brand of brandList" [value]="brand.brandCode">
                        <span class="w-66px">{{brand.brandCode}}</span>
                        <span class="mx-2 hide-ng-dropdown-panel">-</span>
                        <span>{{brand.brandName}}</span>
                      </ng-option>
                    </ng-select>
                    <div *ngIf="cpf.brand.invalid && (cpf.brand.dirty || cpf.brand.touched)"
                      class="help-block text-danger">
                      <div *ngIf="cpf.brand.errors.required"><span translate>lblCompanyRequired</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label for="service" translate>lblPartNumber
                    <strong class="mlt6 required"> * </strong> </label>
                  <div class='lbl-info'>
                    <select class="form-control" formControlName="partNumber" (change)="getDealerList()">
                      <option selected disabled translate *ngIf="partNumber" [ngValue]="null">
                        lblSelectPartNumber
                      </option>
                      <option *ngFor="let partNumber of partNumber" [ngValue]="partNumber.partNumber">
                        {{partNumber.partNumber}}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label translate>lblSelectDealer <strong class="mlt6 required"> * </strong></label>
                  <div class='lbl-info'>
                    <ng-select [multiple]="true" formControlName="dealerName"
                      placeholder="{{ 'lblSelectDealer' | translate }}" [(ngModel)]="SelectedDealer">
                      <ng-option *ngFor="let category of availableDealers" [value]="category.value">
                        {{category.text}}</ng-option>
                    </ng-select>

                    <div *ngIf="cpf.dealerName.invalid && (cpf.dealerName.dirty || cpf.dealerName.touched)"
                      class="help-block text-danger">
                      <div *ngIf="cpf.dealerName.errors.required"><span translate>lblDealerRequired</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label for="name" translate>lblQuantity
                    <strong class="mlt6 required"> * </strong>
                  </label>
                  <div class='lbl-info'>
                    <input formControlName="totalPartQuantity" class="form-control mb-2"
                      [ngClass]="{'is-invalid': cpf.totalPartQuantity.invalid && cpf.totalPartQuantity.touched}"
                      maxlength="20">
                    <div
                      *ngIf="cpf.totalPartQuantity.invalid && (cpf.totalPartQuantity.dirty || cpf.totalPartQuantity.touched)"
                      class="help-block mt-1 text-danger"> <em class="ft-alert-circle align-middle"
                        aria-hidden="true"></em>
                      <span translate>lblTotalQuntityRequired</span>
                    </div>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label>&nbsp;</label>
                  <div class="lbl-info">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                      <label class="custom-control-label" for="isActive" translate>lblActive</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
        <div class="row">
          <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
            <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" [disabled]="!addSpecialToolForm.valid"
              translate aria-label="Center Align"><em class="far fa-save font16 align-top mr-2"></em> lblSaveChanges</button>
            <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
          </div>
        </div>
      </div>
      </form>
    </div>
  </div>
</div>